import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LANG_EPP_EXP, monacoLoadPromise } from './monaco-controller';

/// <reference path = "node_modules/ngx-monaco-editor/lib/types.d.ts" />

export interface Suggestion {
  label: string
  kind?: monaco.languages.CompletionItemKind
  insertText?: string
  detail?: string
  documentation?: string
}
export interface SuggestionGroup {
  suggestions: Suggestion[]
  triggerCharacters?: string[]
}

@Component({
  selector: 'exp-editor',
  templateUrl: './exp-editor.component.html',
  styleUrls: ['./exp-editor.component.scss']
})
export class ExpEditorComponent implements OnInit {

  @Input() suggestionGroups: SuggestionGroup[] = []
  @Input() code = ''

  @Output() codeChange = new EventEmitter<string>()

  editorOptions = {
    language: LANG_EPP_EXP,
    // theme: 'vs-dark'
    theme: 'eppTheme',
    minimap: {
      enabled: false
    },
    lineNumbers: 'off',
    glyphMargin: false,
    folding: false,
    // Undocumented see https://github.com/Microsoft/vscode/issues/30795#issuecomment-410998882
    lineDecorationsWidth: 5,
    lineNumbersMinChars: 0,
    fontSize: 16
  }
  // code = '(col3*2)+col1'
  // code = ''

  constructor () {
    monacoLoadPromise.then(() => {
      this.suggestionGroups.forEach(suggestionGroup => {
        const { suggestions } = suggestionGroup
        monaco.languages.registerCompletionItemProvider(LANG_EPP_EXP, {
          provideCompletionItems: () => {
            return {
              suggestions: suggestions.map(eppSugg => {
                const { label, kind, insertText, detail, documentation } = eppSugg
                return {
                  label: `${label}`,
                  kind: kind || monaco.languages.CompletionItemKind.Variable,
                  insertText,
                  detail,
                  documentation,
                  range: null
                }
              })
            }
          }
        })
      })
    })

  }

  ngOnInit () {
  }

  handleCodeChange (code) {
    this.codeChange.emit(code)
  }

}


